"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFunctionClient = useFunctionClient;
const FunctionClient_1 = require("@juvare/platform-sdk-js/FunctionClient");
const react_1 = __importDefault(require("react"));
function useFunctionClient(baseUrl, tokenProvider) {
    return react_1.default.useMemo(() => new FunctionClient_1.FunctionClient(baseUrl, tokenProvider), [baseUrl, tokenProvider]);
}
